import type { ConfiguratorSlotId } from '@pomoshnik/shared';

/**
 * Резолвит CSS-цвет slot'а для SVG-визуализации Экрана 2.6.2 (Block 6 Phase 2).
 *
 * **Phase 2 контракт:** `selectedItemId` всегда `null` (selection mode не готов
 * до Phase 3 + ADR-0016) → возвращает `SLOT_GREY_FALLBACK`. SVG отображает
 * «пустые» серые зоны, что honest reflects state «слот не выбран».
 *
 * **Phase 3 наполнит:** реальный resolve через lookup в Block 2/4 fixtures —
 *   - facade/countertop/corpus: `Decor.dominantLab` → `labToCssRgb(lab)` (или
 *     `SLOT_GREY_FALLBACK` если dominantLab отсутствует — паттерн three-tier
 *     fallback из `DecorResultCard.tsx`).
 *   - handles/hooks: `Handle.color` (категория «Хром» / «Латунь» и т.п.) →
 *     `HANDLE_COLOR_HEX_MAP[color]` (vocabulary в `packages/shared`).
 *
 * Step 2 экспортирует функцию + grey fallback, Step 3 расширит логикой без
 * изменения сигнатуры.
 */
export const SLOT_GREY_FALLBACK = '#cccccc';

export function resolveSlotColor(
  _slotId: ConfiguratorSlotId,
  selectedItemId: string | null,
): string {
  if (selectedItemId === null) return SLOT_GREY_FALLBACK;
  // Phase 3 наполнит реальный resolve. Для Phase 2 любое не-null значение
  // тоже возвращает grey — selection mode не активен, store не должен
  // содержать non-null selectedItemId. Phase 3 заменит этот return на
  // lookup в Block 2/4 fixtures.
  return SLOT_GREY_FALLBACK;
}
